
export const navActionTypes = {
    TOGGLE: 'TOGGLE',
    SCROLL: 'SCROLL',
    UPDATE_MODAL: 'UPDATE_MODAL',
    UPLOAD_IMG: 'UPLOAD_IMG',
    PROFILE:'PROFILE',
}